import React, { useState } from 'react'
import {
  ShoppingOutlined,
  SnippetsOutlined
} from "@ant-design/icons";
import { Tabs } from "antd";
import JournalStock from '../JournalStock';
import DashbordStock from '../dashbordStock/DashbordStock';
import CouleurMarque from '../couleurMarque/CouleurMarque';
import MonthlyFlux from '../monthlyFlux/MonthlyFlux';

const JournalStockAll = () => {
    const [activeKey, setActiveKey] = useState("1");

    const handleTabChange = (key) => {
        setActiveKey(key);
    };

    const tabItems = [
            {
                key: "1",
                label: (
                    <span style={{ display: "flex", alignItems: "center", gap: 2}}>
                        <SnippetsOutlined style={{ color: "#1890ff" }} />
                        Dashboard
                    </span>
                ),
                children: <DashbordStock />,
            },
            {
                key: "2",
                label: (
                    <span style={{ display: "flex", alignItems: "center", gap: 2 }}>
                        <ShoppingOutlined style={{ color: "#1890ff" }} />
                        Journal de stock
                    </span>
                ),
                children: <JournalStock />,
            },
            {
                key: "3",
                label: (
                    <span style={{ display: "flex", alignItems: "center", gap: 2 }}>
                        <ShoppingOutlined style={{ color: "#1890ff" }} />
                        Flux mensuel de stock
                    </span>
                ),
                children: <MonthlyFlux />,
            },
            {
                key: "4",
                label: (
                    <span style={{ display: "flex", alignItems: "center", gap: 2 }}>
                        <ShoppingOutlined style={{ color: "#1890ff" }} />
                        Couleurs & Matières
                    </span>
                ),
                children: <CouleurMarque />,
            }
    ];

  return (
    <div>
        <Tabs
            activeKey={activeKey}
            onChange={handleTabChange}
            type="card"
            tabPosition="top"
            items={tabItems}
            destroyInactiveTabPane
        />
    </div>
  )
}

export default JournalStockAll